import { createApp } from 'vue/dist/vue.esm-bundler';
import axios from 'axios';

import { debounce } from '../functions';


const quickSearchHomeApp = {
    data() {
        return {
            dataApi: '',
            dataAction: '',

            loading: true,
            data: null,
            searchText: '',
            isInputFocused: false,
            selectedIndex: -1,
            searchFields: [{
                Key: 'title',
                Boost: 1.2,
                DoSuggestions: true
            },
            {
                Key: 'subtitle',
                Boost: 1,
                DoSuggestions: true
            }]
        }
    },
    computed: {
        queryModel() {
            return {
                Limit: 10,
                Offset: 0,
                OrderItems: [],
                FilterItems: [],
                Text: this.searchText,
                SearchFields: this.searchFields,
                SuggestionLimit: 10,
            }
        },
    },
    methods: {
        fetchData() {
            axios
                .post(this.dataApi, this.queryModel)
                .then(response => {
                    if (response.status === 200 && response.data) {
                        this.data = response.data;
                    }
                })
                .catch(error => console.log(error))
                .finally(() => this.loading = false);
        },
        handleBlur() {
            setTimeout(() => {
                this.isInputFocused = false;
            }, 200);
        },
        navigateDropdown(direction) {
            if (!this.data.suggestedSearchTerms.length) return;
            this.isInputFocused = true;

            let newIndex = this.selectedIndex + direction;

            if (newIndex < 0) newIndex = this.data.suggestedSearchTerms.length - 1;
            if (newIndex >= this.data.suggestedSearchTerms.length) newIndex = 0;

            this.selectedIndex = newIndex;
        },
        selectHighlighted(event) {
            event.preventDefault();
            event.stopPropagation();
            if (this.selectedIndex >= 0 && this.selectedIndex < this.data.suggestedSearchTerms.length) {
                this.clickSuggestion(this.data.suggestedSearchTerms[this.selectedIndex].text);
            }
        },
        clickSuggestion(text) {
            window.location.href = this.dataAction + '?text=' + text;
        },
    },
    created() {
        this.changeSearchText = debounce(event => {
            this.fetchData();
        });
    },
    mounted() {
        if (this.$refs.config.dataset.api) this.dataApi = this.$refs.config.dataset.api
        if (this.$refs.config.dataset.action) this.dataAction = this.$refs.config.dataset.action;

        this.fetchData();
    },
};

export default quickSearchHomeApp;